import React from 'react'
import PropTypes from 'prop-types'
import { Router } from '@reach/router'

import Authorize from './Authorize'
import Verify from './Verify'

const Authorization = props => {
  return (
    <Router>
      <Authorize default coursenum={props.coursenum} />
      <Verify path="verify" onVerify={props.onVerify} verify={props.verify} />
    </Router>
  )
}

Authorization.propTypes = {
  coursenum: PropTypes.string.isRequired,
  onVerify: PropTypes.func.isRequired,
  verify: PropTypes.func.isRequired,
}

export default Authorization
